import React, { DetailedHTMLProps, FC, InputHTMLAttributes } from 'react'
import { Check } from './icons/check'

export const Checkbox: FC<
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
> = (props) => (
  <div className="PSCheckbox">
    <input type="checkbox" className="PSCheckbox-input" {...props} />

    <Check className="PSCheckbox-check" />
  </div>
)
